/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDashboardWidgetData } from '../../../../hooks/useWidgetState'
import ErrorMessage from '../../../share/ErrorMessage'
import { ReturnStatus } from '../../../../enums'

// eslint-disable-next-line react/prop-types
const CrosstabLanguageNotSupportedGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData(widgetId)
  const { t } = useTranslation()

  const metrics = widgetData.data[0].results[0].data.crossTabs.flatMap((entry) => entry.metrics)
  const statusList = metrics
    .flatMap((metric) => metric.dataset)
    .map((metricData) => metricData.status)
  if (statusList.some((status) => status === ReturnStatus.LANGUAGE_NOT_SUPPORTED))
    return <ErrorMessage>{t('topicLanguageUnsupported')}</ErrorMessage>

  return children
}

export default CrosstabLanguageNotSupportedGuard
